import { ChangeEvent, FC } from 'react';
import { Input } from '@chakra-ui/react';
import { Column } from '@tanstack/react-table';

const DefaultColumnFilter: FC<{ column: Column<any, any> }> = ({ column }) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        column.setFilterValue(e.target.value || undefined);
    };

    return <Input placeholder="Search..." size="sm" value={(column.getFilterValue() as string) || ''} onChange={handleChange} />;
};

export default DefaultColumnFilter;
